import type { ReactNode } from 'react'

/** A titled block inside a `Card`, set off by a hairline: "Assigned
 *  volunteers" and "Away games" on Home, "Upcoming" and "Played" on Games. */
export function CardSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="border-t border-line pt-3">
      <h3 className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-brand-maroon">{title}</h3>
      {children}
    </div>
  )
}
